import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { RetentionDetailMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RetentionCloums';
import SensorTowerIcon from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import { useIntl } from 'umi';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { pageAble } from '@/pages/intelligence/utils/commonUtils';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { CountriesShareColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CountriesShareCloums';

const CountriesCard = (props: any) => {
  const {
    loading,
    tableData = [],
    chartSegment,
    tableHeaderOptions,
    fixedTableData,
    regionSegVal,
    entityType,
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
    retentionMetricSource = 'appannie',
  } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortTable, setPageSortTable] = useState<any[]>([]);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);
  const [pageIndex, setPageIndex] = useState(1);
  // const [pageSize, setPageSize] = useState(15);
  const [pageSize, setPageSize] = useState(50);

  useEffect(() => {
    onSortChage({
      sortMetric: defaultPageSortAttr?.currentSortMetric,
      sortVal: defaultPageSortAttr?.currentSortValue,
      ratioType: defaultPageSortAttr?.currentRatioType,
    });
    setPageSortAttr(defaultPageSortAttr);
  }, [tableData, defaultPageSortAttr]);

  const handleSortChange = (e: SortByItemType) => {
    onTableSortChage?.(e);
    onSortChage(e);
  };

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData,
      sortParams: e,
      timeProperty: 'date',
      metricProperty: 'name',
      growthProperty: 'dod',
    });
    const pageList = pageAble(sortTable, pageIndex, pageSize);
    // setPageSortTable(pageList);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);
    setSortTableData(sortTable.slice(0));
  };

  const isSensorTowerMonthly = retentionMetricSource === 'sensortower';

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    tableHeaderOptions.forEach((t) => {
      metricCloums.push(
        RetentionDetailMetricColumn({
          dataSource: isSensorTowerMonthly ? 'sensortower' : 'appannie',
          title: t.title,
          svgIcon: isSensorTowerMonthly ? SensorTowerIcon : undefined,
          textContent: isSensorTowerMonthly ? (
            <span style={{ whiteSpace: 'pre-line' }}>
              {formatMessage(
                { id: 'dbi_retention_monthly_sensortower_dx_hover' },
                { metric: t?.key, day: t?.key?.replace(/^D/i, '') },
              )}
            </span>
          ) : (
            <>
              {formatMessage({ id: 'dbi_retention_countries_nd_info' }, { dn: t?.key })}
              <br />
              {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
            </>
          ),
          key: `${t.key}`,
          metricKey: t?.metricKey || t?.key,
          sortMetric: t.key,
          currentSortValue: pageSortAttr?.currentSortValue,
          currentSortKey: `${pageSortAttr?.currentSortMetric}_${pageSortAttr?.currentRatioType}`,
          isNoDropdown: !(chartSegment === t.key) || sortTableData?.length === 1,
          entityType,
          gameName,
          gameCover,
          dateType,
          startDate,
          endDate,
          onSortChage: handleSortChange,
        }),
      );
    });
    return metricCloums;
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    // setPageSize(e.pageSize || 5);
    setPageSize(e.pageSize || 50);
    // onTablePagingChange(e);
    const pageList = pageAble(sortTableData, e.pageIndex, e.pageSize);
    // setPageSortTable(pageList);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);
  };

  return (
    <>
      <TopchartTable
        className="dbi-mobileGames-details-table"
        loading={loading}
        records={pageSortTable}
        tableTotal={sortTableData?.length}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        // pageSizeOptions={[5, 10, 15]}
        pageSizeOptions={[10, 20, 30, 50, 100, 200]}
        // scrollMaxHeight={'calc(100vh - 290px)'}
        columns={[
          CountriesShareColumn({
            countriesShareType: regionSegVal,
          }),
          ...getMetricCloums(),
        ]}
      />
    </>
  );
};

export default CountriesCard;
